import { Model } from '@/models/Model';
export class Curriculum extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Curriculum';
        this.$endpoint = '/curricula';
        this.$fillable = ['is_current', 'name'];
    }
    current() {
        return this.filter('current', true);
    }
}
